export enum ScheduleWindowIssue {
  BELOW_MIN_PATH_TIME = 'belowMinPathTime',
  BELOW_MAX_PATH_TIME = 'belowMaxPathTime',
}
